/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DispositivoMobileSaveConfigDto } from '../../models/dispositivo-mobile-save-config-dto';

export interface ApiDispositivoMobileSaveConfigPost$Params {
    body: DispositivoMobileSaveConfigDto;
}

export function apiDispositivoMobileSaveConfigPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiDispositivoMobileSaveConfigPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiDispositivoMobileSaveConfigPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiDispositivoMobileSaveConfigPost.PATH = '/api/dispositivo-mobile/save-config';
